import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton } from '@mui/material';
import { toast } from 'react-toastify';

export default function WrapUpPageComponent({ heading, text }) {
  const copyToClipboard = (content) => {
    navigator.clipboard
      .writeText(content)
      ?.then(() => toast.success('Copied '));
  };

  return (
    <>
      <div className="flex flex-col border border-gray-300 rounded-xl">
        <div className="bg-[#015A52] text-white p-2 text-base sm:text-xl rounded-t-xl flex justify-between">
          <div>{heading}</div>
          <div className="bg-[#D6FFFB] text-[#015A52] rounded-full">
            <IconButton size="small" onClick={() => copyToClipboard(text)}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </div>
        </div>

        <div className="px-2 py-3">{text}</div>
      </div>
    </>
  );
}
